<ng-container *ngIf="visible">
  <div id="content-screen-loader">
    <img [src]="tenantConfig.loaderUrl" />
  </div>
</ng-container>
